/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpsertTranslationDto } from './upsert-translation-dto';


export interface AutoTranslateDto { 
    /**
     * Source translations written in `sourceLocale`. The `locale` field of each item must match `sourceLocale`.
     */
    translations: Array<UpsertTranslationDto>;
    /**
     * The locale that the provided `translations` are written in. The AI will translate from this language into all other enabled program languages.
     */
    sourceLocale: AutoTranslateDto.SourceLocaleEnum;
}
export namespace AutoTranslateDto {
    export const SourceLocaleEnum = {
        En: 'en',
        Es: 'es',
        De: 'de',
        Fr: 'fr',
        It: 'it',
        Bg: 'bg',
        Ca: 'ca',
        Hu: 'hu'
    } as const;
    export type SourceLocaleEnum = typeof SourceLocaleEnum[keyof typeof SourceLocaleEnum];
}


